module.exports = __webpack_public_path__ + "static/fonts/BMHANNAProOTF.otf?ba635429";